<template>
  <RevEditorialCard
    :key="id"
    :alt="imageAlt"
    :content="text"
    :cta="i18n(translations.readMore)"
    data-selector="buying-guide-card"
    data-test="article-card"
    :image="imageSrc"
    :image-props="imageProps"
    :rel="link?.rel"
    :target="link?.target"
    :title="title"
    :title-kicker="category"
    title-tag="h3"
    :to="link?.href"
    @click="sendTrackingData"
  />
</template>

<script lang="ts" setup>
import { useRoute } from '#imports'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevEditorialCard } from '@ds/components/EditorialCard'

import translations from './ArticleCard.translations'
import type { ArticleCard } from './ArticleCard.types'

const props = defineProps<ArticleCard>()

const i18n = useI18n()
const route = useRoute()

const { trackClick } = useTracking()

function sendTrackingData() {
  const trackingData = {
    name: props.title,
    zone: route.name?.toString() || '',
    value: {
      articleCategory: props.category,
    },
  }

  trackClick(trackingData)
}
</script>
